export default {
  BASE_URL: 'https://www.ticketfairy.com/api',
  BASE_URL_DEV: 'https://sandbox.ticketfairy.com/api',
  BASE_URL_STAG: 'https://test.ticketfairy.com/api',
  CLIENT_ID: 'e9d8f8922797b4621e562255afe90dbf',
  CLIENT_SECRET: 'b89c191eff22fdcf84ac9bfd88d005355a151ec2c83b26b9',

  PRIVACY_POLICY_LINK: 'https://www.ticketfairy.com/privacy-policy/',
  TIMEOUT: 60000,
}
